<script type="ts">
    import cx from 'classnames';

    export let id: string = '';
    export let label: string;
    export let helperText: string;
    export let customClass: string = '';
    export let inline: boolean = false;

    $: wrapperClass = cx('mb-3', customClass, {
        'row': inline,
    });

    $: labelClass = cx('col-form-label', {
        'col-sm-6': inline
    });

    $: inputClass = cx({ 'col-sm-6': inline })
</script>

<div class={wrapperClass}>
    {#if label}
        <label
            for={id}
            class={labelClass}
        >
            {label}
            {#if helperText}

            <div class="help-tip">
                <p>{helperText}</p>
            </div>
            {/if}
        </label>
    {/if}
    <div class={inputClass}>
        <slot></slot>
    </div>
</div>